module.exports.BOSSWatermarkScale = 1.05;
module.exports.BOSSWatermarkRefWidth = 1920;
module.exports.BOSSWatermarkRefHeight = 1080;
module.exports.BOSSWatermarkPeriodRatio = 1.05 * 4360.68 / 1080;
module.exports.BOSSWatermarkRatio = 4360.68 / 1080;


// WEBPACK FOOTER //
// ./js/viscom/boss/soccers/Constants.js